import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import withWidth from "@material-ui/core/withWidth"
import styles from "../../components/ProfileDialog/styles"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import {
  toggleProfileDialog,
  _updateUser,
  updateUser,
  createGalleryImage,
  removeGalleryImage,
  getUser,
  _setEditUser,
} from "../../actions/users"
import { Card, CardContent, Divider } from "@material-ui/core"
import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"
import PositionChip from "../../components/ProfileDialog/PositionChip"
import MapCard from "../../components/ProfileDialog/MapCard"
import { isEmpty, pickBy, capitalize, find } from "lodash"
import Rating from "../../components/Rating"
import Button from "@material-ui/core/Button"
import Avatar from "@material-ui/core/Avatar"
import AutoComplete from "../../components/AutoComplete"
import TextField from "@material-ui/core/TextField"
import AddIcon from "@material-ui/icons/Add"
import MainAppBar from "../../components/MainAppBar"
import update from "immutability-helper"
import {
  createRole,
  removeRole,
  createLocation,
  updateLocation,
  removeLocation,
  createEquipment,
  removeEquipment,
  createNote,
  removeNote,
  updateNote,
  createVehicle,
  uploadFile,
  createPhone,
  removePhone,
  createEmail,
  removeEmail,
  createWebsite,
  removeWebsite,
  updateRole,
  updateEquipment,
  addRating,
  getUsers,
  getRoles,
  getLocations,
  getEquipment,
  getSocialNetworks,
} from "../../actions/misc"
import { openSnackBar } from "../../actions/snack-bar"
import PlacesAutoComplete from "../../components/PlacesAutoComplete"
import classNames from "classnames"
import Input from "@material-ui/core/Input"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import VehicleCard from "../../components/ProfileDialog/VehicleCard"
import Moment from "moment"
import Switch from "@material-ui/core/Switch"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { EditorState, convertToRaw, ContentState } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import draftToHtml from "draftjs-to-html"
import htmlToDraft from "html-to-draftjs"
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import LoadingIconButton from "../../components/LoadingIconButton"
import Cancel from "@material-ui/icons/Cancel"
import EliteImage from "../../assets/images/elite1.png"
import CircularProgress from "@material-ui/core/CircularProgress"
import InfoCircle from "../../components/InfoCircle"
import AddPhotoAlternate from "@material-ui/icons/AddAPhoto"
import "react-image-gallery/styles/css/image-gallery.css"
import ImageGallery from "react-image-gallery"
import CheckCircle from "@material-ui/icons/CheckCircle"
import serialize from "../../store/serialize"
import { pluralize } from "inflection"
import Modal from "@material-ui/core/Modal"
import AddressAutoComplete from "../../components/AddressAutoComplete"
// import {
//   setActiveChatter,
//   getMessages,
//   toggleMessageDrawer
// } from "../../actions/message-drawer"
import Collapse from "@material-ui/core/Collapse"
import ArrowIcon from "@material-ui/icons/ArrowDropDown"
import LoadingIndicator from "../../components/LoadingIndicator"
import PhoneInput from "../../components/PhoneInput/index"
import InfoIcon from "../../components/InfoIcon"
import { hiddenLoginModal } from "../../actions/authentication"
import {
  toggleBookingDialog,
  toggleMessageDialog,
} from "../../actions/companies"
import CrewActionBar from "../../components/CrewActionBar/index"
import TwitterIcon from "@material-ui/icons/Twitter"
import { handleConnect } from "../../utils/handleSocialConnect"

import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"

var HtmlDiffer = require("html-differ").HtmlDiffer,
  htmlDiffer = new HtmlDiffer()

const toolBar = {
    options: ["inline", "list", "colorPicker", "link", "remove", "history"],
    inline: {
      options: ["bold", "italic", "underline"],
    },
    list: {
      options: ["unordered", "ordered"],
    },
  },
  ucwords = str => str.replace(/^(.)|\s+(.)/g, word => word.toUpperCase())

const parseQueryString = () => {
  const str = window.location.search
  const objURL = {}

  str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), ($0, $1, $2, $3) => {
    objURL[$1] = $3
  })
  return objURL
}

class ProfileDialogComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {
        first_name: "",
        last_name: "",
        description: "",
        video: "",
        organization: "",
        phone: "",
        email: "",
        password: "",
        clients: "",
        route: "",
        street_number: "",
        city: "",
        state: "",
        zip: "",
        lat: "",
        lon: "",
      },
      clientsEditorContent: "",
      vehicle: {
        make: "",
        model: "",
        year: "",
      },
      savingProfile: false,
      role: {},
      location: {},
      equipment: {},
      rate: "",
      radius: "30",
      activeTab: 0,
      removingPhones: [],
      removingEmails: [],
      removingWebsites: [],
      noteMenuAnchorEl: null,
      editingNote: null,
      noteEdits: "",
      galleryOpen: false,
      newPhone: "",
      newEmail: "",
      showPositions: false,
      showEquipment: false,
    }
  }

  componentDidMount() {
    this.props
      .dispatch(getUser(this.props.match.params.user_id, false))
      .then(data => this.props.dispatch({ type: "USER::SET", data }))
      .catch(err => console.log([err]))

    this.props.dispatch(getSocialNetworks())
    // ajax conditionals
    if (this.props.users.length === 1) {
      this.props.dispatch(getUsers())
    }
    if (this.props.roles.length === 1) {
      this.props.dispatch(getRoles())
    }
    if (this.props.locations.length === 1) {
      this.props.dispatch(getLocations())
    }
    if (this.props.equipment.length === 1) {
      this.props.dispatch(getEquipment())
    }
    // check for querystring
    const uri = window.location
    const clearUri = () => {
      const clean_uri = uri.toString().substring(0, uri.toString().indexOf("?"))
      window.history.replaceState({}, document.title, clean_uri)
    }
    if (uri.toString().search) {
      const params = parseQueryString()
      if (params.hasOwnProperty("openDialog")) {
        setTimeout(() => {
          switch (params.openDialog) {
            case "book":
              this.handleBook()
              clearUri()
              break
            case "claim":
              this.props.dispatch({
                type: "CLAIM_MODAL",
                payload: { open: true, user: this.props.user },
              })
              clearUri()
              break
            default:
              return false
          }
        }, 500)
      }
    }
  }

  componentDidUpdate(p) {
    const user = this.props.user
    if (user.id && !p.user.id) {
      this.props.dispatch({
        type: "PAGE_TITLE",
        payload: `Crew Mama | Film, Video, Production & Camera Crew Directory | Search Crew Profile Listing`,
      })
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: "USER:SET", data: undefined })
  }

  loadUserData = () => {
    if (Object.keys(this.props.user).length === 1) {
      this.props.dispatch(getUser(this.props.user.id, false)).then(res => {
        this.props.dispatch(_setEditUser(res))
        this.setValues()
      })
    } else {
      this.setValues()
    }
  }
  onEditorStateChange = editorState => {
    this.setState(
      update(this.state, {
        clientsEditorContent: {
          $set: editorState,
        },
        user: {
          clients: {
            $set: draftToHtml(convertToRaw(editorState.getCurrentContent())),
          },
        },
      })
    )
  }
  handleClose = () => {
    if (this.props.user.id === this.props.authenticatedUser.id) {
      if (!this.props.user.has_password && !this.state.user.password) {
        document.getElementById("password").focus()
        this.props.dispatch(
          openSnackBar({
            message: "Please enter a password",
          })
        )
        return
      }
    }
    this.props.dispatch(toggleProfileDialog())
  }
  setValues = () => {
    let newState = update(this.state, {})
    if (!isEmpty(this.props.user)) {
      const {
        description,
        video,
        organization,
        first_name,
        last_name,
        phone,
        email,
        clients,
        route,
        street_number,
        city,
        state,
        zip,
        lat,
        lon,
      } = this.props.user
      // client content conversion
      const contentState = ContentState.createFromBlockArray(
        htmlToDraft(clients).contentBlocks
      )
      newState = {
        ...newState,
        user: {
          ...this.state.user,
          description,
          video,
          organization,
          first_name,
          last_name,
          phone,
          email,
          clients,
          route,
          street_number,
          city,
          state,
          zip,
          lat,
          lon,
        },
        clientsEditorContent: EditorState.createWithContent(contentState),
      }
    }
    this.setState(newState)
  }
  clearState = () => {
    this.setState({
      user: {
        description: "",
        video: "",
        organization: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        password: "",
        clients: "",
        route: "",
        street_number: "",
        city: "",
        state: "",
        zip: "",
        lat: "",
        lon: "",
      },
    })
  }
  ratingChanged = value => {
    const user = this.props.user
    hiddenLoginModal().then(_user => {
      const existingRating = user.ratings.find(
        r =>
          r.company_id === this.props.activeCompany || r.creator_id === _user.id
      )
      let ratingId = undefined
      if (existingRating) {
        ratingId = existingRating.id
      }
      this.props.dispatch(
        addRating(
          value,
          ratingId,
          user.id,
          this.props.authenticatedUser,
          this.props.activeCompany
        )
      )
    })
  }

  onAutoCompleteChange = (val, name) => {
    this.setState(
      update(this.state, {
        [name]: {
          $set: this.props[`${pluralize(name)}`].find(n => n.id === val),
        },
      })
    )
    if (name === "role" && document.getElementById("rate-input")) {
      document.getElementById("rate-input").focus()
    }
  }
  onDelete = (data, name) => {
    // this.setState(update(this.state, {
    //   user: {
    //     [name]: {
    //       '$set': this.state.user[name].filter((s) => s[propName] !== data[propName])
    //     }
    //   }
    // }))
    if (name === "locations") {
      this.props
        .dispatch(removeLocation(data.id, this.props.user.id))
        .then(res => {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              locations: this.props.user.locations.filter(
                l => l.id !== data.id
              ),
            })
          )
        })
    } else if (name === "equipment") {
      this.props
        .dispatch(removeEquipment(data.id, this.props.user.id))
        .then(res => {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              equipment: this.props.user.equipment.filter(
                l => l.id !== data.id
              ),
            })
          )
        })
    } else if (name === "notes") {
      this.props.dispatch(removeNote(data.id, this.props.user.id)).then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: this.props.user.notes.filter(l => l.id !== data.id),
          })
        )
      })
    } else {
      this.props.dispatch(removeRole(data.id, this.props.user.id)).then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            roles: this.props.user.roles.filter(r => r.id !== data.id),
          })
        )
      })
    }
  }
  onPlacesChange = place => {
    this.setState(
      update(this.state, {
        location: {
          $set: place,
        },
      })
    )
    document.getElementById("radius-input").focus()
  }
  onAddressChange = place => {
    let updates = {}
    for (const key in place) {
      updates[key] = {
        $set: place[key] || "",
      }
    }
    this.setState(
      update(this.state, {
        user: {
          ...updates,
        },
      })
    )
  }
  savePosition = e => {
    e.preventDefault()
    this.setState({ savingPosition: true })
    let data = { ...this.state.role, rate: this.state.rate }
    if (data.hasOwnProperty("className")) {
      delete data.className
      delete data.id
    }
    // let functionName = createRole
    let functionName
    let params = [data, this.props.user.id]
    const existingPosition = this.props.user.roles.find(
      l => l.name === data.name
    )
    if (existingPosition) {
      functionName = updateRole
      params.splice(1, 0, existingPosition.id)
    }
    this.props
      .dispatch(functionName(...params))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: "Position Saved",
          })
        )
        if (existingPosition) {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              roles: this.props.user.roles.map(p => {
                if (p.id === existingPosition.id) {
                  p = {
                    ...p,
                    ...data,
                    id: res.id,
                  }
                }
                return p
              }),
            })
          )
        } else {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              roles: [
                ...this.props.user.roles,
                {
                  ...data,
                  id: res.id,
                },
              ],
            })
          )
        }
        this.setState({ savingPosition: false })
        setTimeout(() => {
          this.setState({
            role: {},
            rate: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving position",
          })
        )
        this.setState({ savingPosition: false })
      })
  }
  saveLocation = e => {
    e.preventDefault()
    this.setState({ savingLocation: true })
    let functionName = createLocation
    let params = [
      { ...this.state.location, work_radius: parseInt(this.state.radius, 10) },
      this.props.user.id,
    ]
    const existingLocation = this.props.user.locations.find(l => {
      if (this.state.location.country === "United States") {
        return (
          l.city === this.state.location.city &&
          l.state === this.state.location.state
        )
      } else {
        return (
          l.city === this.state.location.city &&
          l.country === this.state.location.country
        )
      }
    })
    if (existingLocation) {
      functionName = updateLocation
      params.splice(1, 0, existingLocation.id)
    }
    this.props
      .dispatch(functionName(...params))
      .then(res => {
        this.setState({ savingLocation: false })
        if (existingLocation) {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              locations: this.props.user.locations.map(l => {
                if (l.id === existingLocation.id) {
                  l = {
                    ...l,
                    ...this.state.location,
                    work_radius: this.state.radius,
                    id: res.id,
                  }
                }
                return l
              }),
            })
          )
        } else {
          serialize("location", {
            ...this.state.location,
            work_radius: this.state.radius,
            id: res.id,
          }).then(locationData => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                locations: [...this.props.user.locations, locationData],
              })
            )
          })
        }
        setTimeout(() => {
          this.setState({
            location: {},
            radius: "30",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving location",
          })
        )
        this.setState({ savingLocation: false })
      })
  }
  saveEquipment = e => {
    e.preventDefault()
    this.setState({ savingEquipment: true })
    let data = this.state.equipment
    if (data.hasOwnProperty("className")) {
      delete data.className
      delete data.id
    }
    let functionName = createEquipment
    let params = [data, this.props.user.id]
    const existingEquipment = this.props.user.equipment.find(
      l => l.name === data.name
    )
    if (existingEquipment) {
      functionName = updateEquipment
      params.splice(1, 0, existingEquipment.id)
    }
    this.props
      .dispatch(functionName(...params))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: "Equipment Saved",
          })
        )
        if (existingEquipment) {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              equipment: this.props.user.equipment.map(e => {
                if (e.id === existingEquipment.id) {
                  e = {
                    ...e,
                    ...data,
                    id: res.id,
                  }
                }
                return e
              }),
            })
          )
        } else {
          this.props.dispatch(
            _updateUser({
              id: this.props.user.id,
              equipment: [
                ...this.props.user.equipment,
                {
                  ...data,
                  id: res.id,
                },
              ],
            })
          )
        }
        this.setState({ savingEquipment: false })
        setTimeout(() => {
          this.setState({
            equipment: {},
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving equipment",
          })
        )
        this.setState({ savingEquipment: false })
      })
  }
  saveNote = () => {
    this.setState({ savingNote: true })
    this.props
      .dispatch(createNote({ note: this.state.note }, this.props.user.id))
      .then(res => {
        this.setState({ savingNote: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: [
              ...this.props.user.notes,
              {
                note: this.state.note,
                creator_id: this.props.authenticatedUser.id,
                creator_first_name: this.props.authenticatedUser.first_name,
                creator_last_name: this.props.authenticatedUser.last_name,
                creator_profile_image: this.props.authenticatedUser
                  .profile_image,
                created: Moment().utc(),
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            note: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving note",
          })
        )
        this.setState({ savingNote: false })
      })
  }
  handleOpenNoteMenu = e => {
    this.setState({ noteMenuAnchorEl: e.currentTarget })
  }
  handleCloseNoteMenu = () => {
    this.setState({ noteMenuAnchorEl: null })
  }
  handleNoteMenuItemClick = (action, note) => {
    this.handleCloseNoteMenu()
    if (action === "edit") {
      this.setState({ editingNote: note.id, noteEdits: note.note })
    } else if (action === "cancelEdit") {
      this.setState({ editingNote: null, noteEdits: "" })
    } else {
      this.removeNote(note)
    }
  }
  updateNote = () => {
    this.setState({ updatingNote: true })
    this.props
      .dispatch(
        updateNote(
          { note: this.state.noteEdits },
          this.state.editingNote,
          this.props.user.id
        )
      )
      .then(res => {
        this.setState({ updatingNote: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: this.props.user.notes.map(note => {
              if (note.id === this.state.editingNote) {
                note = {
                  ...note,
                  note: this.state.noteEdits,
                  updated: Moment().utc(),
                }
              }
              return note
            }),
          })
        )
        setTimeout(() => {
          this.setState({
            noteEdits: "",
            editingNote: null,
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error updating note",
          })
        )
        this.setState({ updatingNote: false })
      })
  }
  removeNote = note => {
    this.props
      .dispatch(removeNote(note.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            notes: this.props.user.notes.filter(n => n.id !== note.id),
          })
        )
        setTimeout(() => {}, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error deleting note",
          })
        )
      })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    let value = e.target.value

    if (fieldName === "video" && value.match(/^https?:\/\//)) {
      value = value.replace(/^https?:\/\/vimeo.com\//, "")
    }

    let newState = update(this.state, {
      user: {
        [fieldName]: { $set: value },
      },
      // form: {
      //   [fieldName]: {
      //     validity: { $set: validity }
      //   }
      // }
    })
    // newState.form.valid = this.formIsValid(newState.form);
    this.setState(newState)
  }
  handleNewInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    this.setState(
      update(this.state, {
        [fieldName]: {
          $set: value,
        },
      })
    )
  }
  handleNewPhoneChange = value => {
    this.setState(
      update(this.state, {
        newPhone: {
          $set: value,
        },
      })
    )
  }
  handlePhoneChange = value => {
    this.setState(
      update(this.state, {
        user: {
          phone: { $set: value },
        },
      })
    )
  }
  getDiff = () =>
    pickBy(this.state.user, (val, key) => {
      if (key === "clients") {
        return !htmlDiffer.isEqual(val, this.props.user[key])
      } else if (key === "password") {
        return val !== ""
      } else if (key === "phone") {
        return val !== this.props.user.formattedPhone
      } else {
        return val !== this.props.user[key]
      }
    })
  submit = () => {
    if (!this.props.user.has_password && !this.state.user.password) {
      document.getElementById("password").focus()
      this.props.dispatch(
        openSnackBar({
          message: "Please enter a password",
        })
      )
      return
    }
    this.setState({
      savingProfile: true,
    })
    const updates = this.getDiff()
    // if (updates.hasOwnProperty('clients')) {
    //   console.log(this.state.user.clients)
    //   updates.clients = draftToHtml(convertToRaw(this.state.user.clients.getCurrentContent()))
    // }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        let has_password = this.props.user.has_password
        if (this.state.user.password) {
          has_password = true
        }
        this.props.dispatch(
          _updateUser({ ...updates, id: this.props.user.id, has_password })
        )
        this.props.dispatch(
          openSnackBar({
            message: "Crew member updated",
          })
        )
        this.setState({
          savingProfile: false,
        })
        this.handleClose()
      })
      .catch(err => {
        const error = err.response.body.error
        let message = "There was an error updating this crew member"
        if (error.code === "ER_DUP_ENTRY") {
          if (error.sqlMessage.indexOf("for key 'phone'") > -1) {
            message = "That phone number is already in use"
          }
        }
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message,
          })
        )
      })
  }
  updateVehicle = e => {
    this.setState(
      update(this.state, {
        vehicle: {
          [e.target.name]: {
            $set: e.target.value,
          },
        },
      })
    )
  }
  saveVehicle = e => {
    e.preventDefault()
    this.setState({ savingVehicle: true })
    this.props
      .dispatch(createVehicle(this.state.vehicle, this.props.user.id))
      .then(res => {
        this.setState({ savingVehicle: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            vehicles: [
              ...this.props.user.vehicles,
              {
                ...this.state.vehicle,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            vehicle: {
              make: "",
              model: "",
              year: "",
            },
            showAddVehicle: false,
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving vehicle",
          })
        )
        this.setState({ savingVehicle: false })
      })
  }
  avatarChanged = e => {
    const file = e.target.files[0]
    this.setState({ uploadingAvatar: true })
    this.props
      .dispatch(uploadFile(file, `users/${this.props.user.id}/profile_images`))
      .then(image => {
        this.props
          .dispatch(
            updateUser(this.props.user.id, {
              profile_image: JSON.stringify(image),
            })
          )
          .then(() => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                profile_image: image,
              })
            )
            this.setState({ uploadingAvatar: false })
            document.getElementById("profileImage").value = ""
          })
          .catch(err => {
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving avatar",
              })
            )
            this.setState({ uploadingAvatar: false })
            document.getElementById("profileImage").value = ""
          })
      })
      .catch(err => {
        this.setState({ uploadingAvatar: false })
        document.getElementById("profileImage").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving avatar",
          })
        )
      })
  }
  handleTabChange = (event, activeTab) => {
    this.setState({ activeTab })
  }
  handlePublicChanged = e => {
    const isChecked = e.target.checked
    const updates = {
      public: isChecked ? 1 : 0,
    }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        this.props.dispatch(
          _updateUser({ public: isChecked, id: this.props.user.id })
        )
        this.props.dispatch(
          openSnackBar({
            message: updates.public
              ? "Profile set to public"
              : "Profile set to private",
          })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: `There was an error setting this profile to ${
              updates.public ? "public" : "private"
            }`,
          })
        )
      })
  }

  handleSocialConnectSwitch = (e, network, networkId) => {
    const data = {
      creator_id: this.props.authenticatedUser.id,
      network_id: networkId,
    }

    handleConnect(network, this.props.user.id, data)
  }

  handleLaborOnlyChanged = e => {
    const isChecked = e.target.checked
    const updates = {
      labor_only: isChecked ? 1 : 0,
    }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        this.props.dispatch(
          _updateUser({ labor_only: isChecked, id: this.props.user.id })
        )
        this.props.dispatch(
          openSnackBar({
            message: updates.labor_only
              ? "Profile set to labor only"
              : "Profile set to not labor only",
          })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: `There was an error setting labor only`,
          })
        )
      })
  }

  handleVaccinatedChanged = e => {
    const isChecked = e.target.checked
    const updates = {
      vaccinated: isChecked ? 1 : 0,
    }
    this.props
      .dispatch(updateUser(this.props.user.id, updates))
      .then(res => {
        this.props.dispatch(
          _updateUser({ vaccinated: isChecked, id: this.props.user.id })
        )
        this.props.dispatch(
          openSnackBar({
            message: updates.vaccinated
              ? "Profile set to vaccinated"
              : "Profile set to not vaccinated",
          })
        )
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: `There was an error setting vaccinated`,
          })
        )
      })
  }
  addNewPhone = e => {
    e.preventDefault()
    if (this.state.newPhone === this.state.user.phone) {
      this.props.dispatch(
        openSnackBar({
          message: "Phone number is already your primary number",
        })
      )
      return
    }
    this.setState({ addingNewPhone: true })
    this.props
      .dispatch(createPhone({ phone: this.state.newPhone }, this.props.user.id))
      .then(res => {
        this.setState({ addingNewPhone: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            phones: [
              ...this.props.user.phones,
              {
                phone: this.state.newPhone,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            newPhone: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving phone number",
          })
        )
        this.setState({ addingNewPhone: false })
      })
  }
  removePhone = phone => {
    this.setState(
      update(this.state, {
        removingPhones: {
          $push: [phone.id],
        },
      })
    )
    this.props.dispatch(removePhone(phone.id, this.props.user.id)).then(res => {
      this.props.dispatch(
        _updateUser({
          id: this.props.user.id,
          phones: this.props.user.phones.filter(l => l.id !== phone.id),
        })
      )
      this.setState(
        update(this.state, {
          removingPhones: {
            $set: this.state.removingPhones.filter(l => l !== phone.id),
          },
        })
      )
    })
  }
  addNewEmail = e => {
    e.preventDefault()
    if (this.state.newEmail === this.state.user.email) {
      this.props.dispatch(
        openSnackBar({
          message: "Email is already your primary email",
        })
      )
      return
    }
    this.setState({ addingNewEmail: true })
    this.props
      .dispatch(createEmail({ email: this.state.newEmail }, this.props.user.id))
      .then(res => {
        this.setState({ addingNewEmail: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            emails: [
              ...this.props.user.emails,
              {
                email: this.state.newEmail,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            newEmail: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving email address",
          })
        )
        this.setState({ addingNewEmail: false })
      })
  }
  removeEmail = email => {
    this.setState(
      update(this.state, {
        removingEmails: {
          $push: [email.id],
        },
      })
    )
    this.props.dispatch(removeEmail(email.id, this.props.user.id)).then(res => {
      this.props.dispatch(
        _updateUser({
          id: this.props.user.id,
          emails: this.props.user.emails.filter(l => l.id !== email.id),
        })
      )
      this.setState(
        update(this.state, {
          removingEmails: {
            $set: this.state.removingEmails.filter(l => l !== email.id),
          },
        })
      )
    })
  }
  addNewWebsite = e => {
    e.preventDefault()
    this.setState({ addingNewWebsite: true })
    this.props
      .dispatch(
        createWebsite({ website: this.state.newWebsite }, this.props.user.id)
      )
      .then(res => {
        this.setState({ addingNewWebsite: false })
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            websites: [
              ...this.props.user.websites,
              {
                website: this.state.newWebsite,
                id: res.id,
              },
            ],
          })
        )
        setTimeout(() => {
          this.setState({
            newWebsite: "",
          })
        }, 250)
      })
      .catch(err => {
        console.log(err)
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving website",
          })
        )
        this.setState({ addingNewWebsite: false })
      })
  }
  removeWebsite = website => {
    this.setState(
      update(this.state, {
        removingWebsites: {
          $push: [website.id],
        },
      })
    )
    this.props
      .dispatch(removeWebsite(website.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            websites: this.props.user.websites.filter(l => l.id !== website.id),
          })
        )
        this.setState(
          update(this.state, {
            removingWebsites: {
              $set: this.state.removingWebsites.filter(l => l !== website.id),
            },
          })
        )
      })
  }
  shouldShowControls = key => {
    if (!isEmpty(this.props.user) && this.props.authenticatedUser.id) {
      if (this.props.user[key].length > 0) {
        if (this.props.user[key][0].creator_id !== this.props.user.id) {
          return true
        } else {
          return false
        }
      } else {
        if (this.props.accessLevel === 1) {
          return true
        } else {
          return false
        }
      }
    } else {
      return false
    }
  }
  generateAvatar = () => {
    if (!isEmpty(this.props.user)) {
      if (!isEmpty(this.props.user.profile_image)) {
        return (
          <img
            className={this.props.classes.avatarImage}
            src={`https://res.cloudinary.com/${
              process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
            }/image/upload/c_thumb,g_face:auto,z_0.7,h_400,w_400,fl_lossy,f_auto/v${
              this.props.user.profile_image.version
            }/${this.props.user.profile_image.public_id}.${
              this.props.user.profile_image.format
            }`}
            alt={`${this.props.user.first_name} ${this.props.user.last_name}`}
          />
        )
      } else {
        return (
          <Avatar className={this.props.classes.avatar}>
            {this.props.user.first_name.charAt(0)}
            {this.props.user.last_name.charAt(0)}
          </Avatar>
        )
      }
    }
  }
  clickGalleryImageInput = e => {
    e.preventDefault()
    document.getElementById("galleryImage").click()
  }
  galleryUpload = e => {
    const file = e.target.files[0]
    this.setState({ uploadingGalleryImage: true })
    this.props
      .dispatch(uploadFile(file, `users/${this.props.user.id}/gallery_images`))
      .then(image => {
        this.props
          .dispatch(
            createGalleryImage(
              {
                image: JSON.stringify(image),
              },
              this.props.user.id
            )
          )
          .then(res => {
            this.props.dispatch(
              _updateUser({
                id: this.props.user.id,
                gallery: [
                  ...this.props.user.gallery,
                  {
                    image,
                    id: res.id,
                  },
                ],
              })
            )
            this.setState({ uploadingGalleryImage: false })
            document.getElementById("galleryImage").value = ""
          })
          .catch(err => {
            this.setState({ uploadingGalleryImage: false })
            document.getElementById("galleryImage").value = ""
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving gallery image",
              })
            )
          })
      })
      .catch(err => {
        this.setState({ uploadingGalleryImage: false })
        document.getElementById("galleryImage").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving gallery image",
          })
        )
      })
  }
  removeGalleryImage = image => {
    this.props
      .dispatch(removeGalleryImage(image.id, this.props.user.id))
      .then(res => {
        this.props.dispatch(
          _updateUser({
            id: this.props.user.id,
            gallery: this.props.user.gallery.filter(g => g.id !== image.id),
          })
        )
      })
  }
  openGallery = index => {
    this.setState({ galleryOpen: true })
    setTimeout(() => {
      this._imageGallery.slideToIndex(index)
    }, this.props.theme.transitions.duration.enteringScreen + 100)
  }
  // openMessageDrawer = () => {
  //   hiddenLoginModal().then(res => {
  //     this.props.dispatch(setActiveChatter(this.props.user))
  //     this.props.dispatch(
  //       getMessages(this.props.user.id, this.props.activeCompany)
  //     )
  //     this.props.dispatch(toggleMessageDrawer(true))
  //   })
  // }

  handleBook = () => {
    hiddenLoginModal()
      .then(res => {
        this.props.dispatch(toggleBookingDialog(true, this.props.user))
      })
      .catch(err => console.log({ err }))
  }

  handleMessage = () => {
    hiddenLoginModal()
      .then(res => {
        this.props.dispatch(toggleMessageDialog(true, this.props.user))
      })

      .catch(err => console.log({ err }))
  }

  handleActionBarChange = change => {
    this.props.history.push("/", { actionBarState: change })
  }

  render() {
    const { classes, user, networks } = this.props
    const isMe = user.id === this.props.authenticatedUser.id
    const isNotMe = user.id !== this.props.authenticatedUser.id
    let companyRating = undefined
    let myRating = undefined
    let selectedRating = 0
    if (!isEmpty(user) && Object.keys(user).length > 1) {
      if (this.props.accessLevel === 1) {
        companyRating = user.ratings.find(
          r => r.company_id === this.props.activeCompany
        )
      }
      myRating = user.ratings.find(
        r =>
          r.creator_id === this.props.authenticatedUser.id && r.company_id === 0
      )
      if (companyRating) {
        selectedRating = companyRating.score
      } else if (myRating) {
        selectedRating = myRating.score
      }
    }
    const positionCollapse = document.querySelector(
      "#position-collapse > div > div"
    )
    const equipmentCollapse = document.querySelector(
      "#equipment-collapse > div > div"
    )
    return (
      <Fragment>
        {getCurrentHost() === "crewmama" ? (
          <CrewMamaAppBarComponent history={this.props.history} />
        ) : (
          <MainAppBar />
        )}
        <CrewActionBar
          history={this.props.history}
          onChange={this.handleActionBarChange}
          hideSort
          prop={this.props}
        />
        {!isEmpty(user) &&
          Object.keys(user).length > 1 && (
            <Fragment>
              <DialogContent
                // className={classes.dialogContent}
                style={{ paddingTop: "80px" }}
              >
                <Grid
                  container
                  spacing={4}
                  style={{
                    transform: "translate(-50%)",
                    left: "50%",
                    position: "absolute",
                    width: window.innerWidth > 600 ? "60%" : "100%",
                    margin: "auto",
                  }}
                >
                  <Grid item xs={12} sm={4}>
                    <Paper eleation={2} className={classes.avatarPaper}>
                      <div
                        className={classNames(classes.avatarWrapper, {
                          [this.props.classes.imageOverlay]:
                            selectedRating === 6 || selectedRating === -1,
                          [this.props.classes.imageOverlayPreferred]:
                            selectedRating === 6,
                          [this.props.classes.imageOverlayDoNotUse]:
                            selectedRating === -1,
                        })}
                      >
                        {this.state.uploadingAvatar && (
                          <div className={classes.avatarUploadOverlay}>
                            <CircularProgress
                              color="inherit"
                              className={classes.avatarUploadProgress}
                            />
                          </div>
                        )}
                        {isMe && (
                          <label
                            htmlFor="profileImage"
                            className={classes.avatarLabel}
                          >
                            {!this.state.uploadingAvatar && (
                              <div className={classes.addImageOverlay}>
                                <AddPhotoAlternate
                                  className={classes.addPhotoIcon}
                                />
                              </div>
                            )}
                            {this.generateAvatar()}
                            <input
                              type="file"
                              id="profileImage"
                              name="profileImage"
                              className={classes.avatarInput}
                              value={this.state.profileImage}
                              onChange={this.avatarChanged}
                            />
                          </label>
                        )}
                        {isNotMe && this.generateAvatar()}
                      </div>
                      {!isEmpty(user) &&
                        user.badges.length > 0 && (
                          <div className={this.props.classes.badgeWrapper}>
                            <img
                              src={EliteImage}
                              className={this.props.classes.badgeImage}
                              alt="Elite"
                            />
                          </div>
                        )}
                    </Paper>
                    {isMe ? (
                      <Fragment>
                        <Grid
                          container
                          spacing={2}
                          className={classes.nameInputs}
                        >
                          <Grid item xs={6}>
                            <FormControl
                              fullWidth
                              className={classes.marginBottom}
                            >
                              <Input
                                type="text"
                                fullWidth
                                name="first_name"
                                placeholder="First Name"
                                value={this.state.user.first_name}
                                onChange={this.handleInputChange}
                                id="first_name"
                                autoComplete="nope"
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl
                              fullWidth
                              className={classes.marginBottom}
                            >
                              <Input
                                type="text"
                                fullWidth
                                name="last_name"
                                placeholder="Last Name"
                                value={this.state.user.last_name}
                                onChange={this.handleInputChange}
                                id="last_name"
                                autoComplete="nope"
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Fragment>
                    ) : (
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        className={classes.name}
                      >
                        {user.first_name} {user.last_name}
                      </Typography>
                    )}
                    {!isEmpty(user) &&
                      isNotMe && (
                        // <div className={classes.rating}>
                        <Rating
                          avgRating={user.avg_rating}
                          userId={user.id}
                          totalRatings={
                            user.ratings.filter(r => r.score > -1).length
                          }
                          selectedRating={selectedRating}
                          ratingChanged={this.ratingChanged}
                          placement="right"
                        />
                        // {/* </div> */}
                      )}
                    {isNotMe && this.props.authenticatedUser.id ? (
                      // <Typography
                      //   gutterBottom
                      //   variant="caption"
                      //   className={classes.phone}
                      // >
                      //   <a href={`tel:${user.phone}`}>{user.formattedPhone}</a>
                      // </Typography>
                      <div />
                    ) : !this.props.authenticatedUser.id ? (
                      <React.Fragment>
                        <Typography
                          gutterBottom
                          variant="caption"
                          className={classes.phone}
                          style={{ cursor: "pointer", display: "block" }}
                          onClick={e => {
                            hiddenLoginModal()
                          }}
                        >
                          <a style={{ textDecoration: "underline" }}>
                            Login to see Contact info
                          </a>
                        </Typography>
                        <Typography
                          gutterBottom
                          variant="caption"
                          className={classes.phone}
                          style={{ cursor: "pointer" }}
                          onClick={e =>
                            this.props.dispatch({
                              type: "CLAIM_MODAL",
                              payload: { open: true, user: this.props.user },
                            })
                          }
                        >
                          <a style={{ textDecoration: "underline" }}>
                            Claim this profile
                          </a>
                        </Typography>
                      </React.Fragment>
                    ) : null}
                    {isMe && (
                      <div
                        className={classNames(
                          classes.headlineWrapper,
                          classes.marginTop4
                        )}
                      >
                        <Typography variant="h5" className={classes.headline}>
                          Phone Numbers
                        </Typography>
                      </div>
                    )}
                    {isMe && (
                      <PhoneInput
                        value={this.state.user.phone}
                        onChange={this.handlePhoneChange}
                        valid
                      />
                    )}
                    {/* {isMe && (
                      <form
                        onSubmit={this.addNewPhone}
                        className={classes.inputWithAddButton}
                      >
                        <div className={classes.newInputWrapper}>
                          <PhoneInput
                            name="newPhone"
                            id="newPhone"
                            value={this.state.newPhone}
                            onChange={this.handleNewPhoneChange}
                            valid
                          />
                        </div>
                        <div className={classes.addIcon}>
                          <LoadingIconButton
                            working={this.state.addingNewPhone}
                            type="submit"
                          />
                        </div>
                      </form>
                    )} */}
                    {/* {(isMe ||
                      (isNotMe &&
                        (!isEmpty(user) && user.emails.length > 0))) && (
                      <div
                        className={classNames(
                          classes.headlineWrapper,
                          classes.marginTop4
                        )}
                      >
                        <Typography
                          variant="h5"
                          className={classes.headline}
                        >
                          Emails
                        </Typography>
                      </div>
                    )}
                    {isMe && (
                      <FormControl fullWidth>
                        <Input
                          type="text"
                          fullWidth
                          name="email"
                          placeholder="Default Email"
                          value={this.state.user.email}
                          onChange={this.handleInputChange}
                          id="email"
                          autoComplete="nope"
                        />
                      </FormControl>
                    )} */}
                    {/* {!isEmpty(user) &&
                      user.emails.map(email => (
                        <div key={email.id} className={classes.extraLine}>
                          <Typography
                            variant="body2"
                            className={classes.extraLineTypography}
                          >
                            <a href={`mailto:${user.email}`}>{email.email}</a>
                          </Typography>
                          {isMe && (
                            <LoadingIconButton
                              working={
                                this.state.removingEmails.indexOf(email.id) > -1
                              }
                              buttonclicked={() => this.removeEmail(email)}
                              mergeclasses={classes.cancelIcon}
                            >
                              <Cancel />
                            </LoadingIconButton>
                          )}
                        </div>
                      ))} */}
                    {isMe && (
                      <form
                        onSubmit={this.addNewEmail}
                        className={classes.inputWithAddButton}
                      >
                        <div className={classes.newInputWrapper}>
                          <FormControl fullWidth>
                            <Input
                              type="email"
                              fullWidth
                              name="newEmail"
                              placeholder="New Email"
                              value={this.state.newEmail}
                              onChange={this.handleNewInputChange}
                              id="newEmail"
                              autoComplete="nope"
                            />
                          </FormControl>
                        </div>
                        <LoadingIconButton
                          working={this.state.addingNewEmail}
                          type="submit"
                          mergeclasses={classes.addIcon}
                        />
                      </form>
                    )}
                    {/* {isNotMe &&
                      this.props.authenticatedUser.id && (
                        <Typography
                          gutterBottom
                          variant="caption"
                          className={classes.email}
                        >
                          <a onClick={this.handleMessage}>{user.email}</a>
                        </Typography>
                      )} */}
                    {isNotMe && (
                      <div
                        style={{
                          marginTop: "12px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          style={{ marginRight: "8px" }}
                          color="secondary"
                          onClick={this.handleBook}
                          variant="contained"
                        >
                          Book
                        </Button>
                      </div>
                      //message button with funtionality of book here inside div tag
                      // style={{ marginRight: "8px" }}
                      // color="secondary"
                      // onClick={this.handleMessage}
                      // variant="contained"
                    )}
                    {isMe && (
                      <FormControl fullWidth className={classes.marginTop4}>
                        <Input
                          type="password"
                          fullWidth
                          name="password"
                          placeholder="New Password"
                          value={this.state.user.password}
                          onChange={this.handleInputChange}
                          id="password"
                          autoComplete="nope"
                        />
                      </FormControl>
                    )}
                    {isMe && (
                      <FormControl
                        fullWidth
                        className={classNames(
                          classes.marginTop4,
                          classes.marginBottom2
                        )}
                      >
                        <InputLabel htmlFor="description">
                          Description
                        </InputLabel>
                        <Input
                          multiline
                          type="text"
                          fullWidth
                          name="description"
                          value={this.state.user.description}
                          onChange={this.handleInputChange}
                          id="description"
                          margin="none"
                          autoComplete="nope"
                        />
                      </FormControl>
                    )}
                    {isNotMe && (
                      <Typography
                        variant="caption"
                        className={this.props.classes.description}
                      >
                        {this.props.user.description}
                      </Typography>
                    )}
                    {(isMe ||
                      (isNotMe &&
                        (!isEmpty(user) && user.websites.length > 0))) && (
                      <div
                        className={classNames(
                          classes.headlineWrapper,
                          classes.marginTop4
                        )}
                      >
                        <Typography variant="h5" className={classes.headline}>
                          Websites
                        </Typography>
                      </div>
                    )}

                    {!isEmpty(user) &&
                      user.websites.map(website => (
                        <div key={website.id} className={classes.extraLine}>
                          <Typography
                            variant="body2"
                            className={classes.extraLineTypography}
                          >
                            <a
                              href={website.website}
                              target="_blank"
                              rel="nofollow"
                            >
                              {website.website}
                            </a>
                          </Typography>
                          {isMe && (
                            <LoadingIconButton
                              working={
                                this.state.removingWebsites.indexOf(
                                  website.id
                                ) > -1
                              }
                              buttonclicked={() => this.removeWebsite(website)}
                              mergeclasses={classes.cancelIcon}
                            >
                              <Cancel />
                            </LoadingIconButton>
                          )}
                        </div>
                      ))}
                    {isMe && (
                      <form
                        onSubmit={this.addNewWebsite}
                        className={classes.inputWithAddButton}
                      >
                        <div className={classes.newInputWrapper}>
                          <FormControl fullWidth>
                            <Input
                              type="url"
                              fullWidth
                              name="newWebsite"
                              placeholder="New Website"
                              value={this.state.newWebsite}
                              onChange={this.handleNewInputChange}
                              id="newWebsite"
                              autoComplete="nope"
                            />
                          </FormControl>
                        </div>
                        <LoadingIconButton
                          working={this.state.addingNewWebsite}
                          type="submit"
                          mergeclasses={classes.addIcon}
                        />
                      </form>
                    )}
                    {/* social connect start */}
                    {networks &&
                      networks.length > 0 && (
                        <Fragment>
                          {(isMe || (isNotMe && !isEmpty(user))) && (
                            <div
                              className={classNames(
                                classes.headlineWrapper,
                                classes.marginTop4
                              )}
                            >
                              <Typography
                                variant="h5"
                                className={classes.headline}
                              >
                                Linked Accounts
                              </Typography>
                            </div>
                          )}
                          {isMe &&
                            !isEmpty(user) &&
                            isEmpty(user.networks) &&
                            networks.map((network, networkIndex) => {
                              if (network.network === "twitter")
                                return (
                                  <div className={classes.socialSwitchWrapper}>
                                    <TwitterIcon />
                                    <Button
                                      color="primary"
                                      type="button"
                                      onClick={event =>
                                        this.handleSocialConnectSwitch(
                                          event,
                                          network.network,
                                          network.id
                                        )
                                      }
                                    >
                                      Link Twitter
                                    </Button>
                                  </div>
                                )
                            })}

                          {!isEmpty(user) &&
                            !isEmpty(user.networks) &&
                            !isEmpty(networks) &&
                            user.networks.map((network, networkIndex) => {
                              if (network.id) {
                                return (
                                  <div className={classes.switchWrapper}>
                                    <TwitterIcon
                                      className={classes.twitterIcon}
                                    />
                                    <Typography
                                      variant="p"
                                      className={classes.headline}
                                    >
                                      @{
                                        JSON.parse(network.authentication)
                                          .screen_name
                                      }
                                    </Typography>
                                  </div>
                                )
                              }
                            })}
                        </Fragment>
                      )}

                    {/* social connect end */}
                    {isMe && (
                      <AddressAutoComplete
                        className={classes.autoComplete}
                        value={
                          user.street_number
                            ? `${user.street_number} ${user.route} ${
                                user.city
                              }, ${user.state} ${user.zip}`
                            : undefined
                        }
                        InputProps={{ label: "Enter Billing Address" }}
                        InputClasses={{
                          input: classes.placesAutoCompleteInputInput,
                        }}
                        onChange={this.onAddressChange}
                      />
                    )}
                    {isNotMe &&
                      this.props.authenticatedUser.id &&
                      user.street_number && (
                        <Fragment>
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop4
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Billing Address
                            </Typography>
                          </div>
                          <Typography variant="body2">
                            {user.street_number} {user.route}
                            <br /> {user.city}, {user.state} {user.zip}
                          </Typography>
                        </Fragment>
                      )}
                    {isMe && (
                      <div className={classes.switchWrapper}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={user.public}
                              onChange={this.handlePublicChanged}
                              color="primary"
                            />
                          }
                          label="Public Profile"
                        />
                        <InfoCircle>
                          Turning off Public Profile means only you and any
                          organizations that have your mobile number can see
                          your information.
                        </InfoCircle>
                      </div>
                    )}
                    {isMe && (
                      <div className={classes.switchWrapper}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={user.labor_only}
                              onChange={this.handleLaborOnlyChanged}
                              color="primary"
                            />
                          }
                          label="Labor Only"
                        />
                        <InfoCircle>
                          Labor Only allows managers to book you with out any
                          gear.
                        </InfoCircle>
                      </div>
                    )}
                    {isNotMe &&
                      user.labor_only && (
                        <Typography
                          variant="body2"
                          className={classes.laborOnly}
                        >
                          Labor Only<CheckCircle
                            className={classes.laborOnlyIcon}
                          />
                        </Typography>
                      )}

                    {isMe && (
                      <div className={classes.switchWrapper}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={user.vaccinated}
                              onChange={this.handleVaccinatedChanged}
                              color="primary"
                            />
                          }
                          label="Vaccinated"
                        />
                        <InfoCircle>
                          Vaccinated means the person is Fully Vaccinated
                        </InfoCircle>
                      </div>
                    )}
                    {isNotMe &&
                      user.vaccinated && (
                        <Typography
                          variant="body2"
                          className={classes.laborOnly}
                        >
                          Vaccinated<CheckCircle
                            className={classes.laborOnlyIcon}
                          />
                        </Typography>
                      )}
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Fragment>
                      <Card>
                        <CardContent>
                          <Typography variant="h5" align="left">
                            {(function() {
                              const path = window.location.pathname
                                .substring(1, window.location.pathname.length)
                                .split("/")
                              if (path.length > 2) {
                                return `${user.first_name} ${
                                  user.last_name
                                } | ${ucwords(
                                  decodeURIComponent(
                                    path[2].replace(/_/g, "%20")
                                  )
                                )}`
                              } else {
                                return `${user.first_name} ${user.last_name}`
                              }
                            })()}
                          </Typography>
                        </CardContent>
                        <Divider
                          style={{ marginRight: "16px", marginLeft: "16px" }}
                        />
                        <CardContent>
                          <div className={classes.headlineWrapper}>
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Positions
                            </Typography>
                            {(isMe || this.shouldShowControls("roles")) && (
                              <Button
                                size="small"
                                onClick={() =>
                                  this.setState({
                                    showAddPosition: !this.state
                                      .showAddPosition,
                                  })
                                }
                                className={classes.addButton}
                                color="primary"
                              >
                                {this.state.showAddPosition ? "Cancel" : "Add"}
                              </Button>
                            )}
                          </div>
                          {this.state.showAddPosition && (
                            <form
                              onSubmit={this.savePosition}
                              className={classes.inputWrapper}
                            >
                              <AutoComplete
                                className={classNames(classes.autoComplete, {
                                  [classes.marginRight]: !(
                                    this.props.accessLevel === 1 &&
                                    user.id !== this.props.authenticatedUser.id
                                  ),
                                })}
                                // value={this.state.role}
                                caps
                                creatable={false}
                                InputClasses={{
                                  input: classes.autoCompleteInput,
                                }}
                                showValue
                                placeholder="Search Position"
                                onChange={val =>
                                  this.onAutoCompleteChange(val, "role")
                                }
                                // suggestions={this.props.roles}
                                labelKey="name"
                                prop={this.props}
                              />
                              {this.props.accessLevel === 1 &&
                                user.id !== this.props.authenticatedUser.id && (
                                  <TextField
                                    value={this.state.rate}
                                    autoComplete="nope"
                                    id="rate-input"
                                    placeholder="Rate"
                                    type="number"
                                    className={classes.input}
                                    onChange={e =>
                                      this.setState({ rate: e.target.value })
                                    }
                                  />
                                )}
                              <LoadingButton
                                color="primary"
                                size="small"
                                working={this.state.savingPosition}
                                disabled={
                                  isEmpty(this.state.role) ||
                                  (this.props.accessLevel === 1 &&
                                    user.id !==
                                      this.props.authenticatedUser.id &&
                                    !this.state.rate)
                                }
                                type="submit"
                              >
                                <AddIcon color="inherit" />
                              </LoadingButton>
                            </form>
                          )}
                          {(!isEmpty(user) && user.roles.length) > 0 && (
                            <Collapse
                              className={classes.collapse}
                              in={this.state.showPositions}
                              collapsedHeight="33px"
                              id="position-collapse"
                            >
                              {positionCollapse &&
                                positionCollapse.clientHeight > 33 && (
                                  <ArrowIcon
                                    onClick={() =>
                                      this.setState({
                                        showPositions: !this.state
                                          .showPositions,
                                      })
                                    }
                                    className={classNames(
                                      this.props.classes.arrowIcon,
                                      {
                                        [this.props.classes.arrowDown]: this
                                          .state.showPositions,
                                      }
                                    )}
                                  />
                                )}
                              <div className={classes.chipWrapper}>
                                {user.roles.map(role => (
                                  <PositionChip
                                    key={role.id}
                                    position={role.name}
                                    rate={
                                      role.company_id ===
                                        this.props.activeCompany &&
                                      this.props.accessLevel === 1
                                        ? role.rate
                                        : null
                                    }
                                    canRemove={
                                      isMe || this.shouldShowControls("roles")
                                    }
                                    onDelete={() =>
                                      this.onDelete(role, "roles")
                                    }
                                  />
                                ))}
                              </div>
                            </Collapse>
                          )}
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop3
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.headline}
                            >
                              Equipment
                            </Typography>
                            {(isMe || this.shouldShowControls("equipment")) && (
                              <Button
                                size="small"
                                onClick={() =>
                                  this.setState({
                                    showAddEquipment: !this.state
                                      .showAddEquipment,
                                  })
                                }
                                className={classes.addButton}
                                color="primary"
                              >
                                {this.state.showAddEquipment ? "Cancel" : "Add"}
                              </Button>
                            )}
                          </div>
                          {this.state.showAddEquipment && (
                            <form
                              onSubmit={this.saveEquipment}
                              className={classes.inputWrapper}
                            >
                              <AutoComplete
                                className={classNames(
                                  classes.autoComplete,
                                  classes.marginRight
                                )}
                                value={this.state.equipment}
                                caps
                                creatable
                                InputClasses={{
                                  input: classes.autoCompleteInput,
                                }}
                                showValue
                                placeholder="Equipment"
                                onChange={val =>
                                  this.onAutoCompleteChange(val, "equipment")
                                }
                                suggestions={this.props.equipment}
                                labelKey="name"
                              />
                              <LoadingButton
                                color="primary"
                                size="small"
                                working={this.state.savingEquipment}
                                disabled={isEmpty(this.state.equipment)}
                                type="submit"
                              >
                                <AddIcon color="inherit" />
                              </LoadingButton>
                            </form>
                          )}
                          {(!isEmpty(user) && user.equipment.length) > 0 && (
                            <Collapse
                              className={classes.collapse}
                              in={this.state.showEquipment}
                              collapsedHeight="33px"
                              id="equipment-collapse"
                            >
                              {equipmentCollapse &&
                                equipmentCollapse.clientHeight > 33 && (
                                  <ArrowIcon
                                    onClick={() =>
                                      this.setState({
                                        showEquipment: !this.state
                                          .showEquipment,
                                      })
                                    }
                                    className={classNames(
                                      this.props.classes.arrowIcon,
                                      {
                                        [this.props.classes.arrowDown]: this
                                          .state.showEquipment,
                                      }
                                    )}
                                  />
                                )}
                              <div className={classes.chipWrapper}>
                                {!isEmpty(user) &&
                                  user.equipment.map(equipment => (
                                    <PositionChip
                                      key={equipment.id}
                                      position={equipment.name}
                                      canRemove={
                                        isMe ||
                                        this.shouldShowControls("equipment")
                                      }
                                      onDelete={() =>
                                        this.onDelete(equipment, "equipment")
                                      }
                                    />
                                  ))}
                              </div>
                            </Collapse>
                          )}
                          <div
                          // style={{ display: "flex", alignItems: "center" }}
                          >
                            <div style={{ marginRight: "12px" }}>
                              <div
                                className={classNames(
                                  classes.headlineWrapper,
                                  classes.marginTop3
                                )}
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.headline}
                                >
                                  Local Cities
                                </Typography>
                                {(isMe ||
                                  this.shouldShowControls("locations")) && (
                                  <React.Fragment>
                                    <Button
                                      size="small"
                                      onClick={() =>
                                        this.setState({
                                          showAddLocation: !this.state
                                            .showAddLocation,
                                        })
                                      }
                                      className={classes.addButton}
                                      color="primary"
                                    >
                                      {this.state.showAddLocation
                                        ? "Cancel"
                                        : "Add"}
                                    </Button>
                                    <InfoIcon
                                      text="Only select cities where you work local without travel expenses"
                                      placement="right"
                                    />
                                  </React.Fragment>
                                )}
                              </div>
                              {this.state.showAddLocation && (
                                <form
                                  onSubmit={this.saveLocation}
                                  className={classes.inputWrapper}
                                >
                                  <PlacesAutoComplete
                                    className={classes.autoComplete}
                                    value={this.state.location}
                                    InputProps={{ placeholder: "Enter City" }}
                                    InputClasses={{
                                      input:
                                        classes.placesAutoCompleteInputInput,
                                    }}
                                    onChange={this.onPlacesChange}
                                  />
                                  <TextField
                                    value={this.state.radius}
                                    autoComplete="nope"
                                    id="radius-input"
                                    placeholder="Radius"
                                    type="number"
                                    className={classes.input}
                                    onChange={e =>
                                      this.setState({ radius: e.target.value })
                                    }
                                  />
                                  <LoadingButton
                                    color="primary"
                                    size="small"
                                    working={this.state.savingLocation}
                                    disabled={
                                      isEmpty(this.state.location) ||
                                      !this.state.radius
                                    }
                                    type="submit"
                                  >
                                    <AddIcon color="inherit" />
                                  </LoadingButton>
                                </form>
                              )}
                              {(!isEmpty(user) && user.locations.length) >
                                0 && (
                                <div className={classes.citiesWrapper}>
                                  {!isEmpty(user) &&
                                    user.locations.map(pos => (
                                      <MapCard
                                        key={pos.id}
                                        location={pos}
                                        canRemove={
                                          isMe ||
                                          this.shouldShowControls("locations")
                                        }
                                        onRemove={() =>
                                          this.onDelete(pos, "locations")
                                        }
                                      />
                                    ))}
                                </div>
                              )}
                            </div>
                            <div>
                              <div
                                className={classNames(
                                  classes.headlineWrapper,
                                  classes.marginTop3
                                )}
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.headline}
                                >
                                  Vehicle
                                </Typography>
                                {(isMe ||
                                  this.shouldShowControls("vehicles")) &&
                                  user.vehicles.length <= 0 && (
                                    <Button
                                      size="small"
                                      onClick={() =>
                                        this.setState({
                                          showAddVehicle: !this.state
                                            .showAddVehicle,
                                        })
                                      }
                                      className={classes.addButton}
                                      color="primary"
                                    >
                                      Add
                                    </Button>
                                  )}
                              </div>
                              {this.state.showAddVehicle && (
                                <form
                                  onSubmit={this.saveVehicle}
                                  className={classes.inputWrapper}
                                >
                                  <TextField
                                    value={this.state.vehicle.make}
                                    autoComplete="nope"
                                    name="make"
                                    id="make-input"
                                    placeholder="Make"
                                    type="text"
                                    onChange={this.updateVehicle}
                                  />
                                  <TextField
                                    value={this.state.vehicle.model}
                                    autoComplete="nope"
                                    name="model"
                                    id="model-input"
                                    placeholder="Model"
                                    type="text"
                                    className={classes.input}
                                    onChange={this.updateVehicle}
                                  />
                                  <TextField
                                    value={this.state.vehicle.year}
                                    autoComplete="nope"
                                    name="year"
                                    id="year-input"
                                    placeholder="Year"
                                    type="number"
                                    className={classes.marginRight}
                                    onChange={this.updateVehicle}
                                  />
                                  <LoadingButton
                                    color="primary"
                                    size="small"
                                    working={this.state.savingVehicle}
                                    disabled={
                                      !this.state.vehicle.make ||
                                      !this.state.vehicle.model ||
                                      !this.state.vehicle.year
                                    }
                                    type="submit"
                                  >
                                    <AddIcon color="inherit" />
                                  </LoadingButton>
                                </form>
                              )}
                              {(!isEmpty(user) && user.vehicles.length) > 0 &&
                                user.vehicles.map(vehicle => (
                                  <VehicleCard
                                    key={vehicle.id}
                                    vehicle={vehicle}
                                    user={user}
                                    className={classes.vehicle}
                                    canControl={
                                      isMe ||
                                      this.shouldShowControls("vehicles")
                                    }
                                  />
                                ))}
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </Fragment>
                    <Fragment>
                      <Card style={{ marginTop: "16px", marginBottom: "16px" }}>
                        <CardContent>
                          <Typography variant="h5" align="left">
                            Reel
                          </Typography>
                        </CardContent>
                        <Divider
                          style={{
                            marginRight: "16px",
                            marginLeft: "16px",
                          }}
                        />
                        <CardContent>
                          {isMe && (
                            <div className={this.props.classes.vimeoWrapper}>
                              <Typography
                                variant="subtitle1"
                                className={this.props.classes.vimeoLabel}
                              >
                                https://vimeo.com/
                              </Typography>
                              <FormControl
                                fullWidth
                                className={classes.marginBottom}
                              >
                                <Input
                                  type="text"
                                  fullWidth
                                  name="video"
                                  value={this.state.user.video}
                                  onChange={this.handleInputChange}
                                  inputProps={{
                                    pattern: /^\d+$/,
                                  }}
                                  id="video"
                                  autoComplete="nope"
                                />
                              </FormControl>
                            </div>
                          )}
                          {user.video && (
                            <Fragment>
                              <div
                                style={{
                                  padding: "56.25% 0 0 0",
                                  position: "relative",
                                }}
                              >
                                <iframe
                                  title="vimeo-player"
                                  src={`https://player.vimeo.com/video/${
                                    this.props.user.video
                                  }?title=0&byline=0&portrait=0`}
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  frameBorder="0"
                                />
                              </div>
                              <script src="https://player.vimeo.com/api/player.js" />
                            </Fragment>
                          )}
                          {isMe && (
                            <div
                              className={classNames(
                                classes.headlineWrapper,
                                classes.marginTop3
                              )}
                            >
                              <Typography
                                variant="h5"
                                className={classes.headline}
                              >
                                Image Gallery
                              </Typography>
                              {isMe && (
                                <Button
                                  size="small"
                                  color="primary"
                                  onClick={this.clickGalleryImageInput}
                                >
                                  Add
                                </Button>
                              )}
                              <input
                                type="file"
                                id="galleryImage"
                                name="galleryImage"
                                className={classes.avatarInput}
                                value={this.state.galleryImage}
                                onChange={this.galleryUpload}
                              />
                            </div>
                          )}
                          <div className={classes.galleryWrapper}>
                            {user.gallery.map((image, i) => (
                              <Paper
                                key={image.id}
                                eleation={2}
                                onClick={() => this.openGallery(i)}
                                className={classes.galleryPaper}
                              >
                                {isMe && (
                                  <div className={classes.removeIconWrapper}>
                                    <Cancel
                                      onClick={() =>
                                        this.removeGalleryImage(image)
                                      }
                                      className={classes.removeIcon}
                                    />
                                  </div>
                                )}
                                <img
                                  className={this.props.classes.galleryThumb}
                                  src={`https://res.cloudinary.com/${
                                    process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                                  }/image/upload/c_thumb,g_auto,h_400,w_400,fl_lossy,f_auto/v${
                                    image.image.version
                                  }/${image.image.public_id}.${
                                    image.image.format
                                  }`}
                                  alt={`gallery ${image.id}`}
                                />
                              </Paper>
                            ))}
                          </div>
                        </CardContent>
                      </Card>
                    </Fragment>
                    <Fragment>
                      <Card>
                        <CardContent>
                          <Typography variant="h5" align="left">
                            Clients
                          </Typography>
                        </CardContent>
                        <Divider
                          style={{
                            marginRight: "16px",
                            marginLeft: "16px",
                          }}
                        />
                        <CardContent>
                          {isMe && (
                            <Editor
                              toolbar={toolBar}
                              editorState={this.state.clientsEditorContent}
                              onEditorStateChange={this.onEditorStateChange}
                            />
                          )}
                          {isNotMe && (
                            <div
                              dangerouslySetInnerHTML={{ __html: user.clients }}
                            />
                          )}
                        </CardContent>
                      </Card>
                    </Fragment>
                  </Grid>
                </Grid>
              </DialogContent>
              {/* <DialogActions
                className={classes.dialogActions}
                classes={{
                  action: classes.dialogActionsAction
                }}
              >
                <Button
                  color="primary"
                  onClick={this.handleClose}
                  type="button"
                >
                  Close
                </Button>
                {isMe && (
                  <Fragment>
                    <LoadingButton
                      color="secondary"
                      buttonclicked={this.submit}
                      working={this.state.savingProfile}
                      disabled={
                        (!isEmpty(user)
                          ? isEmpty(this.getDiff())
                          : !isEmpty(this.state.form) &&
                            !this.state.form.valid) ||
                        this.state.savingAndCloseProfile
                      }
                      type="button"
                    >
                      Save
                    </LoadingButton>
                  </Fragment>
                )}
              </DialogActions> */}
            </Fragment>
          )}
        {!isEmpty(user) &&
          Object.keys(user).length === 1 && (
            <LoadingIndicator working={true}>
              Loading Crew Profile
            </LoadingIndicator>
          )}
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          className={classes.galleryModal}
          open={this.state.galleryOpen}
          onClose={() => this.setState({ galleryOpen: false })}
        >
          <div className={this.props.classes.modal}>
            {!isEmpty(user) &&
              Object.keys(user).length > 1 && (
                <ImageGallery
                  ref={i => (this._imageGallery = i)}
                  items={user.gallery.map(g => ({
                    original: `https://res.cloudinary.com/${
                      process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                    }/image/upload/fl_lossy,f_auto/v${g.image.version}/${
                      g.image.public_id
                    }.${g.image.format}`,
                    thumbnail: `https://res.cloudinary.com/${
                      process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
                    }/image/upload/c_thumb,g_auto,h_400,w_400,fl_lossy,f_auto/v${
                      g.image.version
                    }/${g.image.public_id}.${g.image.format}`,
                  }))}
                />
              )}
          </div>
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    profileDialogOpen: state.users.profileDialogOpen,
    user: state.users.editUser,
    roles: state.misc.roles,
    locations: state.misc.locations,
    equipment: state.misc.equipment,
    users: state.misc.users,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    networks: state.misc.networks,
  }
}

export default compose(
  connect(mapStateToProps),
  withMobileDialog(),
  withWidth(),
  // withTheme(),
  withStyles(styles)
)(ProfileDialogComponent)
